/**
 * Previsibilidade dos próximos 12 meses — total a receber por mês de vencimento.
 */
import VerticalColumns from '../../../../Components/Analytics/VerticalColumns'
import { formatCurrency } from '../../../../utils/obraAnalytics'

const Previsao12MesesPanel = ({ serie = [], referencia, totalPrevisao = 0 }) => {
    const items = serie.map((r) => ({
        label: r.label ?? r.mes_ano,
        value: Number(r.total || 0),
        displayValue: formatCurrency(r.total),
    }))

    return (
        <div className="space-y-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                    <p className="text-sm font-semibold text-gray-700">Previsibilidade — próximos 12 meses</p>
                    <p className="text-xs text-gray-400 mt-0.5">
                        Total a receber por mês de vencimento a partir de {referencia || 'fim do período'}
                    </p>
                </div>
                <span className="text-xs font-semibold px-3 py-1 rounded-full bg-amber-50 text-amber-800 border border-amber-100">
                    Total projetado: {formatCurrency(totalPrevisao)}
                </span>
            </div>

            <VerticalColumns title="Vencimentos mês a mês" items={items} />
        </div>
    )
}

export default Previsao12MesesPanel
